import MidiPlayer from 'midi-player-js';

const midiPlayer = new MidiPlayer.Player();

export default midiPlayer;
